var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ns-product-detail-carousel__container" },
    [
      _c(
        "NsCarousel",
        {
          staticClass: "ns-product-detail-carousel__carousel",
          attrs: {
            position: _vm.phabletAndDown ? _vm.slideIndex : null,
            spacing: _vm.phabletAndDown ? 0 : 10,
            min: _vm.phabletAndDown ? 1 : 4,
            max: _vm.phabletAndDown ? 1 : 6,
            vertical: _vm.desktopAndUp
          },
          on: { "position-changed": _vm.handlePositionChanged }
        },
        _vm._l(_vm.imageSet, function(item, index) {
          return _c(
            "div",
            {
              key: item.id,
              staticClass: "ns-product-detail-carousel__item",
              class: {
                "ns-product-detail-carousel__item--active":
                  _vm.slideIndex === index
              },
              on: {
                click: function($event) {
                  return _vm.$emit("slide-select", index)
                }
              }
            },
            [
              item.contentType === "img"
                ? _c("NsImage", {
                    attrs: {
                      width: _vm.phabletAndDown ? _vm.getImageWidth() : "50px",
                      height: _vm.phabletAndDown ? _vm.getImageWidth() : "50px",
                      src: item.src,
                      "alt-text": item.alt,
                      "maintain-ratio": "1x1",
                      "image-fit": "contain",
                      "use-src-set": "",
                      itemprop: "image"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              item.contentType === "video"
                ? _c(
                    "video",
                    {
                      attrs: {
                        width: _vm.phabletAndDown
                          ? _vm.getImageWidth()
                          : "50px",
                        height: _vm.phabletAndDown
                          ? _vm.getImageWidth()
                          : "50px",
                        controls: _vm.phabletAndDown
                      }
                    },
                    [
                      _c("source", {
                        attrs: {
                          src: item.src + (_vm.phabletAndDown ? "" : "#t=0.5")
                        }
                      })
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.phabletAndDown
        ? _c(
            "div",
            { staticClass: "ns-product-detail-carousel__dots" },
            _vm._l(_vm.imageSet.length, function(order, index) {
              return _c(
                "button",
                {
                  key: order,
                  staticClass: "ns-product-detail-carousel__dot",
                  class: {
                    "ns-product-detail-carousel__dot--active":
                      index === _vm.slideIndex
                  },
                  on: {
                    click: function($event) {
                      return _vm.$emit("slide-select", index)
                    }
                  }
                },
                [_c("span")]
              )
            }),
            0
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }